"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "matera": {
    "495bab63": [{
      "hkey": "6474ebab",
      "slug": "semicentro-nord",
      "name": "Semicentro Nord",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "e5cc08cc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-direzionale": [{
      "hkey": "e5cc08cc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "matera"
    }],
    "51906b9a": [{
      "hkey": "cef86fc9",
      "slug": "centro-storico-sassi",
      "name": "Centro Storico-Sassi",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "cef86fc9",
      "slug": "centro-storico-sassi",
      "name": "Centro Storico-Sassi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f6a49ac8": [{
      "hkey": "f3df7e05",
      "slug": "giovanni-paolo-secondo-serra-rifusa",
      "name": "Giovanni Paolo Secondo-Serra Rifusa",
      "primary": true,
      "skipSearch": false
    }],
    "periferia-nord": [{
      "hkey": "f3df7e05",
      "slug": "giovanni-paolo-secondo-serra-rifusa",
      "name": "Giovanni Paolo Secondo-Serra Rifusa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "matera"
    }],
    "f19cba5f": [{
      "hkey": "c5f0a021",
      "slug": "agna-cappuccini",
      "name": "Agna-Cappuccini",
      "primary": true,
      "skipSearch": false
    }],
    "periferia-sud": [{
      "hkey": "c5f0a021",
      "slug": "agna-cappuccini",
      "name": "Agna-Cappuccini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "matera"
    }],
    "384863d4": [{
      "hkey": "e5cc08cc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro-sud": [{
      "hkey": "e5cc08cc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "matera"
    }]
  }
};
exports["default"] = _default;